import { Button } from '@longy/web-components'
import { LucideIcon } from 'lucide-react'

type BookingNoticeProps = {
    icon: LucideIcon
    title: string
    description: string
    action?: { label: string; onClick: () => void }
}

/**
 * What a booking flow shows in place of itself when there is nothing to choose from.
 *
 * Two situations reach it and they must not be confused. Nothing is bookable — every catalogue query
 * passes `withBookableSlotsOnly`, so an empty first step means nobody has a free slot — or the
 * request failed, which react-query also reports as settled with no data. Telling a visitor there is
 * no availability when the API was merely unreachable is the worse of the two mistakes, so the
 * caller picks the icon, the wording and whether there is anything to retry.
 */
export const BookingNotice = ({ icon: Icon, title, description, action }: BookingNoticeProps) => (
    <div className="flex flex-col items-center gap-3 rounded-lg bg-slate-50 px-6 py-16 text-center">
        <Icon className="size-8 text-brand-gray" />
        <h2 className="text-lg font-semibold text-brand-dark">{title}</h2>
        <p className="max-w-md text-sm text-brand-gray">{description}</p>
        {action && (
            <Button className="mt-2" variant="outline" onClick={action.onClick}>
                {action.label}
            </Button>
        )}
    </div>
)
